import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import {
  CategoryForm,
  ProductForm,
  RollForm,
  SupplierForm,
} from './crud.interface';
// import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CrudService {
  private http = inject(HttpClient);

  // Category
  getCategories() {
    return this.http.get(`${environment.apiUrl}/category`, {
      observe: 'response',
    });
  }

  createCategory(formValue: CategoryForm) {
    return this.http.post(`${environment.apiUrl}/category`, formValue, {
      observe: 'response',
    });
  }

  updateCategory(categoryId: any, formValue: CategoryForm) {
    return this.http.patch(
      `${environment.apiUrl}/category/${categoryId}`,
      formValue,
      {
        observe: 'response',
      },
    );
  }

  deleteCategory(categoryId: any) {
    return this.http.delete(`${environment.apiUrl}/category/${categoryId}`, {
      observe: 'response',
    });
  }

  // Supplier
  getSuppliers() {
    return this.http.get(`${environment.apiUrl}/supplier`, {
      observe: 'response',
    });
  }

  createSupplier(formValue: SupplierForm) {
    return this.http.post(`${environment.apiUrl}/supplier`, formValue, {
      observe: 'response',
    });
  }

  updateSupplier(supplierId: any, formValue: SupplierForm) {
    return this.http.patch(
      `${environment.apiUrl}/supplier/${supplierId}`,
      formValue,
      {
        observe: 'response',
      },
    );
  }

  deleteSupplier(supplierId: any) {
    return this.http.delete(`${environment.apiUrl}/supplier/${supplierId}`, {
      observe: 'response',
    });
  }

  // Product
  getProducts() {
    return this.http.get(`${environment.apiUrl}/product`, {
      observe: 'response',
    });
  }

  getProductsForSale() {
    return this.http.get(`${environment.apiUrl}/product?forSale=true`, {
      observe: 'response',
    });
  }

  createProduct(formValue: ProductForm) {
    return this.http.post(`${environment.apiUrl}/product`, formValue, {
      observe: 'response',
    });
  }

  updateProduct(productId: any, formValue: ProductForm) {
    return this.http.patch(
      `${environment.apiUrl}/product/${productId}`,
      formValue,
      {
        observe: 'response',
      },
    );
  }

  deleteProduct(productId: any) {
    return this.http.delete(`${environment.apiUrl}/product/${productId}`, {
      observe: 'response',
    });
  }

  // Roll
  getProductRolls() {
    return this.http.get(`${environment.apiUrl}/product-roll`, {
      observe: 'response',
    });
  }

  getProductRollsByProductId(productId: string) {
    return this.http.get(
      `${environment.apiUrl}/product-roll/by-product/${productId}`,
      {
        observe: 'response',
      },
    );
  }

  createProductRoll(formValue: any) {
    return this.http.post(`${environment.apiUrl}/product-roll`, formValue, {
      observe: 'response',
    });
  }

  updateProductRoll(rollId: any, formValue: RollForm) {
    return this.http.patch(
      `${environment.apiUrl}/product-roll/${rollId}`,
      formValue,
      {
        observe: 'response',
      },
    );
  }

  deleteProductRoll(rollId: any) {
    return this.http.delete(`${environment.apiUrl}/product-roll/${rollId}`, {
      observe: 'response',
    });
  }

  // Enums
  getEnum(enumName: string) {
    return this.http.get(`${environment.apiUrl}/enums/${enumName}`, {
      observe: 'response',
    });
  }

  // Cart
  getCartList() {
    return this.http.get(`${environment.apiUrl}/cart`, {
      observe: 'response',
    });
  }

  createCart() {
    return this.http.post(
      `${environment.apiUrl}/cart`,
      {
        name: `VENTA-${Date.now().toString()}`,
      },
      {
        observe: 'response',
      },
    );
  }

  getCartDetail(cartId: string) {
    return this.http.get(`${environment.apiUrl}/cart/${cartId}`, {
      observe: 'response',
    });
  }

  addItemToCart(cartId: string, formValue: any) {
    return this.http.post(
      `${environment.apiUrl}/cart/${cartId}/items`,
      formValue,
      {
        observe: 'response',
      },
    );
  }

  updateItemInCart(itemId: string, formValue: any) {
    return this.http.patch(
      `${environment.apiUrl}/cart/items/${itemId}`,
      formValue,
      {
        observe: 'response',
      },
    );
  }

  deleteItemInCart(itemId: string) {
    return this.http.delete(`${environment.apiUrl}/cart/items/${itemId}`, {
      observe: 'response',
    });
  }

  // Sales
  createSale(cartId: string, body: any) {
    return this.http.post(
      `${environment.apiUrl}/sales/from-cart/${cartId}`,
      body,
      {
        observe: 'response',
      },
    );
  }

  // Users
  getUsers() {
    return this.http.get(`${environment.apiUrl}/user`, {
      observe: 'response',
    });
  }

  createUser(formValue: any) {
    return this.http.post(`${environment.apiUrl}/user`, formValue, {
      observe: 'response',
    });
  }

  updateUser(userId: any, formValue: any) {
    return this.http.patch(`${environment.apiUrl}/user/${userId}`, formValue, {
      observe: 'response',
    });
  }

  deleteUser(userId: any) {
    return this.http.delete(`${environment.apiUrl}/user/${userId}`, {
      observe: 'response',
    });
  }

  // Warehouses
  getWarehouses() {
    return this.http.get(`${environment.apiUrl}/warehouse`, {
      observe: 'response',
    });
  }

  createWarehouse(formValue: any) {
    return this.http.post(`${environment.apiUrl}/warehouse`, formValue, {
      observe: 'response',
    });
  }

  updateWarehouse(warehouseId: any, formValue: any) {
    return this.http.patch(
      `${environment.apiUrl}/warehouse/${warehouseId}`,
      formValue,
      {
        observe: 'response',
      },
    );
  }

  deleteWarehouse(warehouseId: any) {
    return this.http.delete(`${environment.apiUrl}/warehouse/${warehouseId}`, {
      observe: 'response',
    });
  }
}
